import React, { useEffect, useState, useCallback } from "react";
import {
  FaHandPointRight,
  FaPhone,
  FaWhatsapp,
  FaPlayCircle,
} from "react-icons/fa";
import apiInstance from "../utils/axios"; // Assuming this path is correct
import moment from "moment";
import GradientText from '../ui/GradientText';
import { motion } from "framer-motion";
import { FaChartPie, FaHeadset, FaUsers, FaBolt, FaUser, FaDownload, FaUserPlus, FaGamepad, FaWallet, FaChartLine, FaShieldAlt } from "react-icons/fa";
import GameRates from './GameRates';

function Hero() {
  const [games, setGames] = useState([]);
  const [charts, setCharts] = useState([]); // Added from user's latest input
  const [declaredResults, setDeclaredResults] = useState([]);
  const today = moment().format("YYYY-MM-DD");
  console.log(charts)

  const [whatsapp, setWhatsapp] = useState("");
  const [mobile, setMobile] = useState("");
  const [current, setCurrent] = useState(null);

  // Removed detectArchitecture and downloadUrl state as the download link is now hardcoded in JSX
  // and the original provided code didn't use the state for the download button's href.
  useEffect(() => {
    fetchCurrent();
  }, []);

  const fetchCurrent = async () => {
    try {
      const res = await apiInstance.get("/api/app/version");
      setCurrent(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getResultStringForGame = (gameName) => {
    const gameResults = declaredResults.filter(
      (item) =>
        item.gameName.trim().toUpperCase() === gameName.trim().toUpperCase()
    );
    const openResult = gameResults.find((item) => item.gameType === "open");
    const closeResult = gameResults.find((item) => item.gameType === "close");

    if (openResult && closeResult) {
      return `${openResult.panna}-${openResult.digit}${closeResult.digit}-${closeResult.panna}`;
    } else if (openResult && !closeResult) {
      return `${openResult.panna}-${openResult.digit}*-***`;
    } else if (!openResult && closeResult) {
      return `***-*${closeResult.digit}-${closeResult.panna}`;
    } else {
      return "***-**-***";
    }
  };

  useEffect(() => {
    const fetchWhatsapp = async () => {
      try {
        const res = await apiInstance.get('/api/settings/general/whatsapp');
        setWhatsapp(res.data.whatsappnumber);
        setMobile(res.data.mobile);
      } catch (err) {
        console.log(err);
      }
    };
    fetchWhatsapp();
  }, []);

  const fetchGames = async () => {
    try {
      const response = await apiInstance.get("/api/marketManagement/getMarketGames");
      const data = response.data || [];
      const activeGames = data.filter((game) => game.isActive);
      const currentDay = moment().format("dddd");

      const mappedGames = activeGames.map((game) => {
        const weekendRecord = game.weekends.find(
          (item) => item.day.toLowerCase() === currentDay.toLowerCase()
        );

        let status = game.is_open ? "Running" : "Closed for today";
        let displayOpenTime = game.openTime;
        let displayCloseTime = game.closeTime;
        const gameName = game.gameName || game.name || 'unknown-game';

        const cleanGameName = gameName.toString()
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '');

        if (weekendRecord) {
          if (!weekendRecord.is_on || !weekendRecord.is_open) {
            status = "Closed for today";
            displayOpenTime = weekendRecord.openTime;
            displayCloseTime = weekendRecord.closeTime;
          } else {
            status = "Running";
          }
        }

        return {
          name: game.gameName.toUpperCase(),
          originalName: game.gameName,
          openTime: displayOpenTime,
          closeTime: displayCloseTime,
          status,
          createdAt: game.createdAt,
          jodiChart: `/mrecords/${cleanGameName}-jodi-chart`,
          pannaChart: `/mrecords/${cleanGameName}-panel-chart`,
        };
      });

      const sortedGames = mappedGames.sort((a, b) =>
        moment(a.createdAt).diff(moment(b.createdAt))
      );
      setGames(sortedGames);
    } catch (error) {
      console.error("Error fetching games:", error);
    }
  };

  const fetchDeclaredResults = useCallback(async () => {
    try {
      const response = await apiInstance.get("/api/mainmarketdeclareResult/DeclareResult");
      const results = response.data.results || [];
      const todayResults = results.filter(
        (item) => item.date === today && item.marketName === "Main Market"
      );
      setDeclaredResults(todayResults);
      setCharts(response.data.results ? Object.entries(response.data.results) : []);
    } catch (error) {
      console.error("Error fetching declared results:", error);
    }
  }, [today]);

  useEffect(() => {
    fetchGames();
  }, []);

  useEffect(() => {
    fetchDeclaredResults();
  }, [fetchDeclaredResults]);

  const gameCardColors = [
    "bg-gradient-to-r from-orange-500 to-orange-700",
    "bg-gradient-to-r from-pink-500 to-pink-700",
    "bg-gradient-to-r from-blue-500 to-blue-700",
    "bg-gradient-to-r from-green-500 to-green-700",
    "bg-gradient-to-r from-red-500 to-red-700",
    "bg-gradient-to-r from-purple-500 to-purple-700",
    "bg-gradient-to-r from-indigo-500 to-indigo-700",
    "bg-gradient-to-r from-teal-500 to-teal-700"
  ];

  const getRandomColor = () => {
    return gameCardColors[Math.floor(Math.random() * gameCardColors.length)];
  };

  return (
    <div className="bg-white text-gray-800"> {/* Main container for light theme */}

      <section className="relative w-full py-24 bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000] text-white overflow-hidden">

        {/* Floating background elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-20 text-4xl">🎲</div>
          <div className="absolute top-32 right-32 text-4xl">🪙</div>
          <div className="absolute bottom-20 left-40 text-4xl">🎰</div>
          <div className="absolute bottom-10 right-20 text-4xl">💎</div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto text-center px-6">

          {/* Title */}
          <GradientText
            colors={["#FFFFFF", "#3a0000", "#FFFFFF"]}
            animationSpeed={8}
            showBorder={false}
            className="custom-class text-6xl md:text-8xl font-bold"
          >
            India's No.1 Sai Matka
          </GradientText>
          {/* <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            India's No.1 <span className="text-red-400">Sai</span>
            <br />
            <span className="text-red-300">Matka</span>
          </h1> */}

          {/* Subtitle */}
          <p className="mt-6 text-lg md:text-xl text-gray-200">
            The Ultimate Premium Matka Gaming Experience
          </p>

          {/* Download Button */}
          <div className="mt-10">
            <motion.a
              href={current?.apk_url}
              className="inline-flex items-center gap-3 bg-red-500 text-white px-8 py-4 rounded-full text-lg font-semibold 
    shadow-[0_10px_25px_rgba(239,68,68,0.6)] hover:shadow-[0_15px_35px_rgba(239,68,68,0.9)] transition-all duration-300"

              animate={{ y: [0, -20, 0] }}

              transition={{
                duration: 0.1,   // ⬅ faster
                repeat: Infinity,
                ease: "easeInOut"
              }}

              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaHandPointRight />
              Download Now
            </motion.a>
          </div>

          {/* Call + Whatsapp buttons */}
          <div className="flex justify-center gap-6 mt-10 flex-wrap">

            <a
              href={`tel:+91${mobile}`}
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-xl shadow-lg"
            >
              <FaPhone />
              Call Us
            </a>

            <a
              href={`https://wa.me/+91${whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-500 hover:bg-green-600 px-6 py-3 rounded-xl shadow-lg"
            >
              <FaWhatsapp />
              WhatsApp
            </a>

          </div>

        </div>
      </section>

      {/* Available Games Section */}
      <section id="availableGames" className="w-full h-auto pt-0 p-4 bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000] text-white">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-gray-800">
            <span className="text-yellow-400">Available Games</span>
          </h2>
          <p className="separator text-white">We have multiple types of games for you!</p>
        </div>

        <div className="md:grid md:grid-cols-3 md:gap-4">

          {games.map((game, index) => (

            <div
              key={index}
              className={`${getRandomColor()} rounded-lg grid grid-cols-2 pt-3 h-32 shadow-lg my-2 px-4 text-white`}
            >

              <div>
                <h3 className="font-bold text-lg">{game.name}</h3>

                <h2 className="font-bold text-xl mt-1">
                  {getResultStringForGame(game.name)}
                </h2>

                <a
                  className="text-sm underline"
                  href={`/jodi-chart/${game.name}`}
                >
                  View Chart
                </a>
              </div>

              <div className="flex flex-col items-end justify-center">
                <a href={current?.apk_url}>
                  <FaPlayCircle size={35} className="text-yellow-300" />
                </a>

                <span className="text-sm mt-1">Play Now</span>
              </div>

            </div>

          ))}

        </div>
      </section>
      <section className="w-full py-5 bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000]">
        <div className="max-w-7xl mx-auto px-6">

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

            {/* Card 1 */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaChartPie className="text-red-400 text-4xl mx-auto mb-4" />
              <h2 className="text-4xl font-bold text-white">20+</h2>
              <p className="text-gray-300 mt-2">Markets</p>
            </div>

            {/* Card 2 */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaHeadset className="text-red-400 text-4xl mx-auto mb-4" />
              <h2 className="text-4xl font-bold text-white">24/7</h2>
              <p className="text-gray-300 mt-2">Support</p>
            </div>

            {/* Card 3 */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaUsers className="text-red-400 text-4xl mx-auto mb-4" />
              <h2 className="text-4xl font-bold text-white">100K+</h2>
              <p className="text-gray-300 mt-2">Players</p>
            </div>

            {/* Card 4 */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaBolt className="text-red-400 text-4xl mx-auto mb-4" />
              <h2 className="text-4xl font-bold text-white">Instant</h2>
              <p className="text-gray-300 mt-2">Withdrawal</p>
            </div>

          </div>

        </div>
      </section>

      <section className="w-full py-5 bg-gradient-to-r from-[#2e0000] via-[#3c0606] to-[#3a0000] text-white">

        <div className="max-w-7xl mx-auto px-6">

          {/* Title */}
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-red-400">Daily Winners</h2>
            <p className="text-gray-300 mt-3">
              Join our community of winners and start your success story today
            </p>
          </div>

          {/* Winners Grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

            {[
              { name: "Suresh Kumar", amount: "₹13,166" },
              { name: "Laxman Singh", amount: "₹6,396" },
              { name: "Gopal Singh", amount: "₹13,819" },
              { name: "Narayan Das", amount: "₹11,325" },
            ].map((winner, index) => (

              <div
                key={index}
                className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition"
              >

                <div className="w-16 h-16 flex items-center justify-center bg-red-500 rounded-full mx-auto mb-4 shadow-lg">
                  <FaUser className="text-white text-xl" />
                </div>

                <h3 className="text-xl font-semibold">{winner.name}</h3>

                <p className="text-red-400 text-2xl font-bold mt-2">
                  {winner.amount}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>
      <section className="w-full py-5 bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000] text-white">

        <div className="max-w-7xl mx-auto px-6">

          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-red-400">How to Play</h2>
            <p className="text-gray-300 mt-3">
              Start your premium gaming journey in 3 simple steps
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            {/* Step 1 */}
            <div className="relative bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">

              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-red-500 w-12 h-12 flex items-center justify-center rounded-full font-bold text-lg shadow-lg">
                01
              </div>

              <FaDownload className="text-red-400 text-4xl mx-auto mb-6 mt-4" />

              <h3 className="text-xl font-semibold mb-2">Download App</h3>

              <p className="text-gray-300">
                Download our premium app from the website
              </p>

            </div>

            {/* Step 2 */}
            <div className="relative bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">

              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-red-500 w-12 h-12 flex items-center justify-center rounded-full font-bold text-lg shadow-lg">
                02
              </div>

              <FaUserPlus className="text-red-400 text-4xl mx-auto mb-6 mt-4" />

              <h3 className="text-xl font-semibold mb-2">Create Account</h3>

              <p className="text-gray-300">
                Register with your details securely
              </p>

            </div>

            {/* Step 3 */}
            <div className="relative bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">

              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-red-500 w-12 h-12 flex items-center justify-center rounded-full font-bold text-lg shadow-lg">
                03
              </div>

              <FaGamepad className="text-red-400 text-4xl mx-auto mb-6 mt-4" />

              <h3 className="text-xl font-semibold mb-2">Start Playing</h3>

              <p className="text-gray-300">
                Choose your game and start winning
              </p>

            </div>

          </div>

        </div>

      </section>
      <section className="w-full pt-5 bg-gradient-to-r from-[#2e0000] via-[#3c0606] to-[#3a0000] text-white">

        <div className="max-w-7xl mx-auto px-6 pb-5">

          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-red-400">
              Why Choose 24/7 Sai Matka?
            </h2>
            <p className="text-gray-300 mt-3">
              Experience the difference with our premium features
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

            {/* Fast Withdrawal */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaWallet className="text-red-400 text-4xl mx-auto mb-6" />

              <h3 className="text-xl font-semibold mb-3">
                Fast Withdrawal
              </h3>

              <p className="text-gray-300">
                Get your winnings quickly with our seamless withdrawal process.
              </p>
            </div>

            {/* Markets */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaChartLine className="text-red-400 text-4xl mx-auto mb-6" />

              <h3 className="text-xl font-semibold mb-3">
                20+ Markets
              </h3>

              <p className="text-gray-300">
                Explore a wide variety of markets to place your bets.
              </p>
            </div>

            {/* Secure */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaShieldAlt className="text-red-400 text-4xl mx-auto mb-6" />

              <h3 className="text-xl font-semibold mb-3">
                Secure Platform
              </h3>

              <p className="text-gray-300">
                Play with confidence on our secure and reliable platform.
              </p>
            </div>

            {/* Support */}
            <div className="bg-[#5c0a0a]/60 backdrop-blur-lg border border-red-400/20 rounded-2xl p-10 text-center shadow-lg hover:scale-105 transition">
              <FaHeadset className="text-red-400 text-4xl mx-auto mb-6" />

              <h3 className="text-xl font-semibold mb-3">
                24/7 Support
              </h3>

              <p className="text-gray-300">
                Our team is here to assist you anytime, anywhere.
              </p>
            </div>

          </div>

        </div>
        <GameRates />
      </section>
    </div>
  );
}

export default Hero;
